import type { TOC } from '@ember/component/template-only';
import { PrismModal } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import HotelOverviewDashboardModalsAlertsSettings from 'lumen/components/hotel/overview-dashboard/modals/alerts-settings';
import type HotelOverviewSettingsController from 'lumen/controllers/hotel/overview/settings';

interface HotelOverviewSettingsSignature {
  Args: {
    controller: HotelOverviewSettingsController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.closeODSettingsModal}}
    @title={{t "overview_dashboard.settings.modal.title"}}
  >
    <HotelOverviewDashboardModalsAlertsSettings
      @closeModal={{@controller.closeODSettingsModal}}
      {{! @glint-expect-error: Incorrect type }}
      @compsetId={{@controller.overviewDashboardController.compsetId}}
      @otaId={{@controller.overviewDashboardController.otaId}}
      @rateParam={{@controller.overviewDashboardController.rateParam}}
    />
  </PrismModal>
</template> satisfies TOC<HotelOverviewSettingsSignature>;
